import React, { useRef } from 'react';

import Input from 'component/Search/Input';

import classNames from 'classnames';

import { AutocompleterProps } from '../types';

import { useAutocompleter } from './__hooks/useAutocompleter';

import styles from './Autocompleter.module.scss';

const Autocompleter = ({
    children,
    errorMessage,
    toggle = false,
    searchValue = '',
    placeholder = '',
    label = '',
    withClearButton = false,
    customClassList,
    autocompleterWrapperRef,
    validatorList = [],
    onSearch,
    onSearchInputClick,
    onBlur,
    onFocus,
    onClear,
    qaId,
}: AutocompleterProps) => {
    const ref = useRef<HTMLInputElement>(null);
    const {
        onBlur_,
        onChange,
        onClick,
        handleCursor,
        isClearButtonVisible,
        setIsClearButtonVisible,
    } = useAutocompleter({
        onSearch,
        onSearchInputClick,
        onBlur,
        validatorList,
        searchValue,
        ref,
    });

    return (
        <div
            ref={autocompleterWrapperRef}
            className={classNames(
                styles.AutoCompleteWrapper,
                customClassList?.autocompleterWrapper
            )}
        >
            <Input
                labelText={label}
                placeholder={placeholder}
                value={searchValue}
                forwardRef={ref}
                callbacks={{
                    onClick,
                    onBlur: onBlur_,
                    onFocus,
                    onChange: handleCursor,
                    onValueChange: onChange,
                    onSelect: handleCursor,
                }}
                qaId={qaId}
                customClassList={{
                    InputWrapper: classNames(
                        styles.InputWrapper,
                        customClassList?.InputWrapper
                    ),
                    Input: classNames(
                        customClassList?.Input,
                        styles.DefaultSearchInput,
                        {
                            [styles.SearchinputWithClearButton]:
                                withClearButton && isClearButtonVisible,
                        }
                    ),
                    Label: customClassList?.Label,
                }}
                isReadOnly={false}
            >
                {withClearButton && isClearButtonVisible && (
                    <button
                        className={classNames(
                            styles.ButtonDefault,
                            styles.ClearButton
                        )}
                        onClick={() => {
                            setIsClearButtonVisible(false);
                            onClear?.();
                        }}
                    />
                )}
            </Input>

            {errorMessage}
            {toggle && children}
        </div>
    );
};

export default Autocompleter;
